import {
  CHECK,
  CHECK_FAILURE,
  CHECK_SUCCESS,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  GOOGLE_INITIALIZED,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAILURE,
  LOGOUT_SUCCESS,
  REGISTER_SAGA,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_SUCCESS,
  SENT_RESET_PASSWORD,
  SENT_RESET_PASSWORD_FAILURE,
  SENT_RESET_PASSWORD_PENDING,
  SENT_RESET_PASSWORD_SUCCESS,
  GET_USERDATA,
  GET_USERDATA_SUCCESS,
  GET_USERDATA_FAILURE,
  GET_SUBLIST,
  GET_SUBLIST_SUCCESS,
  GET_SUBLIST_FAILURE,
  UPDATE_USER,
  UPDATE_USER_FAILURE,
  UPDATE_USER_SUCCESS,
  SET_PASSWORD,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  TOGGLE_MENU,
  UPDATE_ALL_FEED_ACCESS,
} from "./constants";
const actions = {
  registerSaga: () => {
    return {
      type: REGISTER_SAGA,
    };
  },
  login: (credentials, history) => {
    return {
      type: LOGIN,
      credentials,
      history,
    };
  },
  loginSuccess: (payload) => {
    return {
      type: LOGIN_SUCCESS,
      payload,
    };
  },
  loginFailure: (error) => {
    return {
      type: LOGIN_FAILURE,
      error,
    };
  },
  check: (token, history) => {
    return {
      type: CHECK,
      token,
      history,
    };
  },

  checkSuccess: (payload) => {
    return {
      type: CHECK_SUCCESS,
      payload,
    };
  },
  checkFailure: (error) => {
    return {
      type: CHECK_FAILURE,
      error,
    };
  },
  updateUser: (token, history, onUpdateSuccess) => {
    return {
      type: UPDATE_USER,
      token,
      history,
      onUpdateSuccess,
    };
  },

  updateUserSuccess: (payload) => {
    return {
      type: UPDATE_USER_SUCCESS,
      payload,
    };
  },
  updateUserFailure: (error) => {
    return {
      type: UPDATE_USER_FAILURE,
      error,
    };
  },
  logout: (history) => {
    return {
      type: LOGOUT,
      history,
    };
  },
  logoutSuccess: (payload) => {
    return {
      type: LOGOUT_SUCCESS,
      payload,
    };
  },
  logoutFailure: (error) => {
    return {
      type: LOGOUT_FAILURE,
      error,
    };
  },
  setGoogleReference: (payload) => {
    return {
      type: GOOGLE_INITIALIZED,
      payload,
    };
  },
  sentResetLink: (payload) => {
    return {
      type: SENT_RESET_PASSWORD,
      payload,
    };
  },
  sentResetLinkPending: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_PENDING,
      payload,
    };
  },
  sentResetLinkSuccess: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_SUCCESS,
      payload,
    };
  },
  sentResetLinkFailure: (payload) => {
    return {
      type: SENT_RESET_PASSWORD_FAILURE,
      payload,
    };
  },

  forgotPassword: (credentials, onSuccess) => {
    return {
      type: FORGOT_PASSWORD,
      credentials,
      onSuccess,
    };
  },
  forgotPasswordSuccess: (payload) => {
    return {
      type: FORGOT_PASSWORD_SUCCESS,
      payload,
    };
  },
  forgotPasswordFailure: (error) => {
    return {
      type: FORGOT_PASSWORD_FAILURE,
      error,
    };
  },
  resetPassword: (credentials, history) => {
    return {
      type: RESET_PASSWORD,
      credentials,
      history,
    };
  },
  resetPasswordSuccess: (payload, onResetSuccess) => {
    return {
      type: RESET_PASSWORD_SUCCESS,
      payload,
      onResetSuccess,
    };
  },
  resetPasswordFailure: (error) => {
    return {
      type: RESET_PASSWORD_FAILURE,
      error,
    };
  },
  getUserData: (payload) => {
    return {
      type: GET_USERDATA,
      payload,
    };
  },
  getUserDataSuccess: (payload) => {
    return {
      type: GET_USERDATA_SUCCESS,
      payload,
    };
  },
  getUserDataFailure: (error) => {
    return {
      type: GET_USERDATA_FAILURE,
      error,
    };
  },
  getSubList: (payload) => {
    return {
      type: GET_SUBLIST,
      payload,
    };
  },
  getSubListSuccess: (payload) => {
    return {
      type: GET_SUBLIST_SUCCESS,
      payload,
    };
  },
  getSubListFailure: (error) => {
    return {
      type: GET_SUBLIST_FAILURE,
      error,
    };
  },
  setPassword: (credentials, history) => {
    return {
      type: SET_PASSWORD,
      credentials,
      history,
    };
  },
  setPasswordSuccess: (payload, onSetSuccess) => {
    return {
      type: SET_PASSWORD_SUCCESS,
      payload,
      onSetSuccess,
    };
  },
  setPasswordFailure: (error) => {
    return {
      type: SET_PASSWORD_FAILURE,
      error,
    };
  },
  toggleMenu: (payload) => {
    return {
      type: TOGGLE_MENU,
      payload,
    };
  },
  updateAllFeedAccess: (payload) => {
    return {
      type: UPDATE_ALL_FEED_ACCESS,
      payload,
    };
  },
};
export default actions;
